import { AccountHolderType, AccountType } from "src/api";

export enum PaymentMethodType {
    CreditCard = "credit-card",
    ACH = "ach",
    PayByBank = "pay-by-bank"
};

export enum BankAccountHolderType {
    Personal = "personal",
    Business = "business"
}

export enum BankAccountType {
    Checking = "checking",
    Savings = "savings",
};

export type BankAccountTypeValues = BankAccountType.Checking | BankAccountType.Savings;
export type BankAccountHolderTypeValues = BankAccountHolderType.Personal | BankAccountHolderType.Business;

export enum CreditCardType {
    Visa = "Visa",
    AmericanExpress = "American Express",
    Discover = "Discover",
    MasterCard = "MasterCard",
    Other = "Card"
};

export interface ConnectedBankAccount {
    bankIcon: string;
    bankName?: string | undefined;
    accountName: string;
    accountMask: string;
    selected: boolean;
    accountType: string;
    bankId?: string | undefined;
    accountId?: string | undefined;
    publicToken?: string | undefined;
    verificationStatus?: string | undefined;
}

interface PaymentMethodInfoBase {
    paymentMethodId: number;
    primary: boolean;
    name: string;
    selected: boolean;
    icon: string;
    expires?: string | undefined;
    customerName?: string | undefined;
    bankName?: string | undefined;
    bankId?: string | undefined;
    number?: string | undefined;
    paymentMethodType: PaymentMethodType,
    displayText?: string | undefined;
    customerId?: number;
    membership?: boolean;
    disconnected?: boolean | undefined;
    routingNumber?: string | undefined;
    token?: string | undefined;
    accountId?: string | undefined;
    bankAccountType?: BankAccountHolderType | undefined;
    postalCode?: string | undefined;
    cvv?: string | undefined;
    verificationStatus?: string | undefined;
    storePaymentMethod?: boolean | undefined; /* Only used for credit card to save and charge at same time */
}

export interface BankAccountMethodInfo extends PaymentMethodInfoBase {
    paymentMethodType: PaymentMethodType.ACH;
    accountType: AccountType;
    accountHolderType: AccountHolderType;
}

export interface CreditCardMethodInfo extends PaymentMethodInfoBase {
    paymentMethodType: PaymentMethodType.CreditCard;
}

export interface PayByBankMethodInfo extends PaymentMethodInfoBase {
    paymentMethodType: PaymentMethodType.PayByBank;
    accountName?: string | undefined;
}

export type PaymentMethodInfo = BankAccountMethodInfo | CreditCardMethodInfo | PayByBankMethodInfo;
